import { t as localeText } from "@/shared/lib/translate";
import { api } from "./client";
import { unwrap } from "./errors";
import type { components } from "./contract";

type V2Reusable = components["schemas"]["V2Reusable"];

export async function listReferences(): Promise<V2Reusable[]> {
  const items: V2Reusable[] = [];
  const seen = new Set<string>();
  let cursor: string | undefined;
  do {
    const page = unwrap(await api.GET("/v1/references", { params: { query: { limit: 100, ...(cursor ? { cursor } : {}) } } }));
    items.push(...page.items);
    cursor = page.next_cursor;
    if (cursor && seen.has(cursor)) throw new Error(localeText("interface.repeated_reference_cursor_e7af3367", { defaultValue: "Repeated reference cursor" }));
    if (cursor) seen.add(cursor);
  } while (cursor);
  return items;
}

export async function createReference(body: components["schemas"]["V2ReusableRequest"]): Promise<V2Reusable> {
  return unwrap(await api.POST("/v1/references", { body }));
}
